import React from "react";
import { CheckCircle2, AlertTriangle, XCircle } from "lucide-react";

export function TrafficLight({ verdict, testid }) {
  if (!verdict) return null;
  const map = {
    good: { color: "var(--green)", bg: "rgba(52, 211, 153, 0.10)", border: "rgba(52,211,153,0.4)", Icon: CheckCircle2 },
    fair: { color: "var(--amber)", bg: "rgba(251, 191, 36, 0.10)", border: "rgba(251,191,36,0.4)", Icon: AlertTriangle },
    poor: { color: "var(--red)", bg: "rgba(248, 113, 113, 0.10)", border: "rgba(248,113,113,0.4)", Icon: XCircle },
  };
  const c = map[verdict.level] || map.fair;
  return (
    <div
      data-testid={testid || `verdict-${verdict.level}`}
      className="glass rounded-xl p-5 flex items-start gap-4 fade-up"
      style={{ background: c.bg, borderColor: c.border }}
    >
      <c.Icon className="w-8 h-8 shrink-0 mt-0.5" style={{ color: c.color }} strokeWidth={2} />
      <div>
        <div className="flex items-center gap-3 mb-1">
          <span className="font-display text-xl font-semibold" style={{ color: c.color }}>
            {verdict.label}
          </span>
          <span className="text-xs font-mono uppercase tracking-wider text-[var(--text-muted)]">
            {verdict.level}
          </span>
        </div>
        <p className="text-sm text-[var(--text-dim)] leading-relaxed">{verdict.message}</p>
      </div>
    </div>
  );
}
